import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import classNames from 'classnames';

import './ObservationForm.scss';

export interface IObservationFormProps {
    main: any;
}

@observer
export class ObservationForm extends TechseeBaseComponent<IObservationFormProps> {
    renderInternal(): JSX.Element {
        const {main} = this.props;

        if (!main.enableObservation) {
            return <React.Fragment />;
        }

        const dashboardState = main.dashboardState;

        if (!dashboardState.displayObserverSendingForm || main.observerDetails?.connected) {
            return <React.Fragment />;
        }

        const showTabs = main.allowSendByEmail && main.allowInviteBySms;
        const isSmsTab = dashboardState?.observationCurrentTab === main.inviteMethodTypes.SMS;
        const isEmailTab = dashboardState?.observationCurrentTab === main.inviteMethodTypes.EMAIL;

        return (
            <form
                className={classNames('observation-form-container', {'no-tabs': !showTabs})}
                onSubmit={(e) => {
                    e.preventDefault();
                    main.onSubmitObserver();
                }}
                noValidate>
                {showTabs && (
                    <div className='tab-container'>
                        <div
                            onClick={() => main.observerTabChange(main.inviteMethodTypes.EMAIL)}
                            className={classNames('tab', {'unchosen-tab': !isEmailTab})}>
                            <span>{main.translate('INVITE.VIEW.EMAIL')}</span>
                        </div>
                        <div
                            onClick={() => main.observerTabChange(main.inviteMethodTypes.SMS)}
                            className={classNames('tab', {'unchosen-tab': !isSmsTab})}>
                            <span>{main.translate('INVITE.VIEW.SMS')}</span>
                        </div>
                    </div>
                )}
                <div className='observation-content'>
                    <span>
                        {isSmsTab
                            ? main.translate('DASHBOARD.VIEW.INVITE_OBSERVER_BY_SMS')
                            : main.translate('DASHBOARD.VIEW.INVITE_OBSERVER_BY_EMAIL')}
                    </span>

                    {isSmsTab && (
                        <div
                            className={classNames('form-group invite-phone-wrapper', {
                                'country-div': main.addCountryCodeToSms
                            })}>
                            {/* ts-country-select would be rendered here */}
                            <input
                                type='text'
                                name='mobile-dashboard-phone'
                                id='mobile-dashboard-phone'
                                className='input-content'
                                value={dashboardState.phoneToInviteObserver ?? ''}
                                onChange={(e) => main.setPhoneToInviteObserver(e.target.value)}
                                placeholder={main.translate('DASHBOARD.VIEW.PHONE_NUMBER')}
                                pattern={main.mobilePhonePattern?.source}
                                required
                                autoFocus
                            />
                        </div>
                    )}

                    {isEmailTab && (
                        <input
                            type='text'
                            name='mobile-dashboard-email'
                            id='mobile-dashboard-email'
                            className='input-content'
                            value={dashboardState?.emailToInviteObserver ?? ''}
                            onChange={(e) => main.setEmailToInviteObserver(e.target.value)}
                            placeholder={main.translate('DASHBOARD.VIEW.SEND_EMAIL')}
                            pattern={main.emailPattern?.source}
                            required
                            autoFocus
                        />
                    )}

                    {main.observationForm?.$submitted && (
                        <div className='ts-invite-message' dir={main.dir}>
                            {isSmsTab && main.observationForm?.['mobile-dashboard-phone']?.$error?.pattern && (
                                <div className='ts-error-message' role='alert'>
                                    <div>{main.translate('INVITE.VIEW.INCORRECT_NUMBER')}</div>
                                </div>
                            )}
                            {isSmsTab && main.observationForm?.['mobile-dashboard-phone']?.$error?.required && (
                                <div className='ts-error-message' role='alert'>
                                    <div>{main.translate('INVITE.VIEW.NUMBER_REQUIRED')}</div>
                                </div>
                            )}
                            {isEmailTab && main.observationForm?.['mobile-dashboard-email']?.$error?.pattern && (
                                <div className='ts-error-message' role='alert'>
                                    <div>{main.translate('DASHBOARD.VIEW.INCORRECT_EMAIL')}</div>
                                </div>
                            )}
                            {isEmailTab && main.observationForm?.['mobile-dashboard-email']?.$error?.required && (
                                <div className='ts-error-message' role='alert'>
                                    <div>{main.translate('DASHBOARD.VIEW.EMAIL_REQUIRED')}</div>
                                </div>
                            )}
                        </div>
                    )}

                    <div className='button-container'>
                        <button type='submit' className='button-style'>
                            {main.translate('DASHBOARD.VIEW.OBSERVER.SEND')}
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}
